import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

/* ✅ CORRECT RESULT COMPONENTS (mobile equivalent) */
import PracticeHistory from "./PracticeHistory";
import ScholarshipResultList from "./ScholarshipResultList";
import MegaScholarshipResultList from "./MegaScholarshipResultList";

export default function ResultHub() {
  const [tab, setTab] = useState("practice");
  const nav = useNavigate();

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={containerStyle}>
          {/* ================= HEADER (mobile-like) ================= */}
          <div style={headerStyle}>
            <img src="/logo.png" alt="EduAt10" style={logoStyle} />
            <h2 style={titleStyle}>📊 My Results</h2>

            <button
              onClick={() => nav("/user/dashboard")}
              style={backBtnStyle}
            >
              ← Back to Dashboard
            </button>
          </div>

          {/* ================= TABS ================= */}
          <div style={tabsWrapper}>
            <TabButton
              label="🧠 Practice"
              active={tab === "practice"}
              onClick={() => setTab("practice")}
            />

            <TabButton
              label="🎓 Scholarship"
              active={tab === "scholarship"}
              onClick={() => setTab("scholarship")}
            />

            <TabButton
              label="🏆 Mega"
              active={tab === "mega"}
              onClick={() => setTab("mega")}
            />
          </div>

          {/* ================= TAB CONTENT ================= */}
          <div style={contentArea}>
            {tab === "practice" && <PracticeHistory />}

            {tab === "scholarship" && <ScholarshipResultList />}

            {tab === "mega" && <MegaScholarshipResultList />}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ================= TAB BUTTON ================= */
function TabButton({ label, active, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        ...tabBtnStyle,
        background: active ? "#2563eb" : "#ffffffcc",
        color: active ? "#fff" : "#334155",
      }}
    >
      {label}
    </button>
  );
}

/* ================= BACKGROUND ================= */
const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};

const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 16,
};

const containerStyle = {
  background: "rgba(255,255,255,0.92)",
  borderRadius: 16,
  padding: 24,
};

/* ================= HEADER ================= */
const headerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 8,
  marginBottom: 16,
};

const logoStyle = {
  width: 120,
};

const titleStyle = {
  fontSize: 20,
  fontWeight: 800,
};

const backBtnStyle = {
  padding: "8px 14px",
  borderRadius: 8,
  border: "none",
  cursor: "pointer",
  background: "#e2e8f0",
};

/* ================= TABS ================= */
const tabsWrapper = {
  display: "flex",
  gap: 8,
  background: "#ffffffcc",
  borderRadius: 14,
  padding: 6,
  marginBottom: 16,
  flexWrap: "wrap",
};

const tabBtnStyle = {
  flex: 1,
  padding: "10px 14px",
  borderRadius: 10,
  border: "none",
  cursor: "pointer",
  fontWeight: 700,
};

/* ================= CONTENT ================= */
const contentArea = {
  marginTop: 10,
};
